// Mock data for ISN Rénovation & Construction

export const services = [
  {
    id: 1,
    title: "Plâtrerie – Peinture",
    description: "Travaux de plâtrerie et peinture intérieure/extérieure avec finitions soignées pour tous types de surfaces.",
    icon: "paintbrush"
  },
  {
    id: 2,
    title: "Isolation extérieure & intérieure",
    description: "Amélioration de l'efficacité énergétique de votre bâtiment avec des solutions d'isolation performantes.",
    icon: "home"
  },
  {
    id: 3,
    title: "Carrelage",
    description: "Pose de carrelage pour sols et murs, cuisine, salle de bain et espaces extérieurs.",
    icon: "grid3x3"
  },
  {
    id: 4,
    title: "Sanitaire",
    description: "Installation et rénovation complète de salles de bain, WC et systèmes sanitaires.",
    icon: "droplet"
  },
  {
    id: 5,
    title: "Toiture",
    description: "Réfection, entretien et réparation de toitures pour garantir l'étanchéité et la durabilité.",
    icon: "triangle"
  },
  {
    id: 6,
    title: "Nettoyage",
    description: "Nettoyage professionnel de fin de chantier et entretien régulier de vos espaces.",
    icon: "sparkles"
  },
  {
    id: 7,
    title: "Démolition & débarras",
    description: "Services de démolition et débarras pour préparer vos projets de rénovation.",
    icon: "hammer"
  }
];

export const portfolioItems = [
  {
    id: 1,
    title: "Rénovation appartement Genève",
    category: "Peinture & Plâtrerie",
    image: "https://images.unsplash.com/photo-1581858726788-75bc0f6a952d?w=800&q=80",
    description: "Rénovation complète d'un appartement de 120m² avec peinture et plâtrerie."
  },
  {
    id: 2,
    title: "Isolation maison Lausanne",
    category: "Isolation",
    image: "https://images.unsplash.com/photo-1504917595217-d4dc5ebe6122?w=800&q=80",
    description: "Isolation thermique extérieure d'une maison individuelle."
  },
  {
    id: 3,
    title: "Salle de bain moderne",
    category: "Sanitaire & Carrelage",
    image: "https://images.unsplash.com/photo-1552321554-5fefe8c9ef14?w=800&q=80",
    description: "Rénovation complète de salle de bain avec carrelage et sanitaires."
  },
  {
    id: 4,
    title: "Réfection toiture Valais",
    category: "Toiture",
    image: "https://customer-assets.emergentagent.com/job_5afc2ed6-4e7e-434c-9c3c-c30efcfdf78e/artifacts/aws7ntb5_haut%20de%20toiture%201.jpeg",
    description: "Réfection complète de toiture avec pose d'ardoises sur chalet en Valais."
  },
  {
    id: 5,
    title: "Réfection toiture Valais",
    category: "Toiture",
    image: "https://customer-assets.emergentagent.com/job_5afc2ed6-4e7e-434c-9c3c-c30efcfdf78e/artifacts/nd61i1nj_haut%20de%20toiture%202.jpeg",
    description: "Pose d'ardoises neuves avec finitions soignées, chalet en altitude."
  },
  {
    id: 6,
    title: "Réfection toiture Valais",
    category: "Toiture",
    image: "https://customer-assets.emergentagent.com/job_5afc2ed6-4e7e-434c-9c3c-c30efcfdf78e/artifacts/85x7erlc_toiture%20de%20cot%C3%A9%201.jpeg",
    description: "Vue d'ensemble du chantier de rénovation de toiture sur chalet en bois."
  },
  {
    id: 7,
    title: "Réfection toiture Valais",
    category: "Toiture",
    image: "https://customer-assets.emergentagent.com/job_5afc2ed6-4e7e-434c-9c3c-c30efcfdf78e/artifacts/e2ql6e4a_toiture%20de%20cot%C3%A9%202.jpeg",
    description: "Chantier de réfection de toiture avec échafaudage et pose d'ardoises."
  },
  {
    id: 8,
    title: "Cuisine carrelage",
    category: "Carrelage",
    image: "https://images.unsplash.com/photo-1556911220-bff31c812dba?w=800&q=80",
    description: "Pose de carrelage mural et au sol dans une cuisine moderne."
  },
  {
    id: 9,
    title: "Rénovation bureau",
    category: "Peinture",
    image: "https://images.unsplash.com/photo-1497366216548-37526070297c?w=800&q=80",
    description: "Rénovation et peinture d'espaces de bureaux professionnels."
  },
  {
    id: 10,
    title: "Mur décoratif en placo - TV & cheminée",
    category: "Peinture & Plâtrerie",
    image: "https://customer-assets.emergentagent.com/job_5afc2ed6-4e7e-434c-9c3c-c30efcfdf78e/artifacts/qozm4hdi_mur%20en%20placo.png",
    description: "Création d'un mur décoratif en placo avec TV et cheminée encastrée, éclairage LED intégré et finitions béton ciré."
  }
];

export const companyInfo = {
  name: "ISN Rénovation & Construction",
  tagline: "CONSTRUIRE – RÉNOVER – EMBELLIR",
  description: "Entreprise spécialisée dans la rénovation pour petits ou grands travaux. Notre priorité : la qualité des finitions et votre satisfaction.",
  motto: "Petits ou grands travaux, une seule exigence : LA QUALITÉ !",
  phone: "+41 79 503 86 65",
  email: "info@isnrenovation.ch",
  values: [
    "Sérieux et professionnalisme",
    "Respect des délais",
    "Finitions soignées",
    "Accompagnement de A à Z",
    "Écoute et conseil personnalisé"
  ]
};